import { render } from "./index.vue?vue&type=template&id=2665560a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2665560a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2665560a"],['__file',"src/vab/components/VabNotice/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2665560a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2665560a', __exports__)) {
    console.log('reload')
    api.reload('2665560a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2665560a&scoped=true", () => {
    console.log('re-render')
    api.rerender('2665560a', render)
  })

}


export default __exports__